import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { DataListModel } from './../../shared/config';
import { ContractTypeGroupService } from './../../contracttypegroup/models/contracttypegroup.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SubscriptionModel } from '../models/sharedvehiclegroupsubscription.model';
import { KeyPairAmount } from '../models/IntervalKeyPairAmount';
import { SubscriptionService } from '../models/sharedvehiclegroupsubscription.service';
import { SharedVehicleGroupService } from './../../sharedvehiclegroup/models/sharedvehiclegroup.service';
import { SharedVehicleGroupModel } from './../../sharedvehiclegroup/models/sharedvehiclegroup.model';
import {
  WeGoConfig,
  IAPIResponse,
  IKeyValueInterface,
  ApplicationRouteURL
} from '../../shared/config';
import { Location } from '@angular/common';
import {
  VatSettingsModel,
  VatDefaultModel
} from '../../vat-setting/models/vat-settings.model';
import { DropdownModel } from '../../report/models/report-filter.model';

@Component({
  selector: 'wego-subscription-update',
  template: require('../views/sharedvehiclegroupsubscription-update.component.html'),
  providers: [
    SubscriptionService,
    SharedVehicleGroupService,
    ContractTypeGroupService
  ]
})
export class SubscriptionUpdateComponent implements OnInit, OnDestroy {
  subscriptionHashId: string;
  sub: any;
  timeIntervalList: any;
  paymentIntervalList: any;
  invoiceIntervalList: any;
  freeKiloMetersIntervalList: any;
  freeMinutIntervalList: any;
  model: SubscriptionModel;
  contractTypeGroupList: any;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlSubscriptionList: string;
  errorMessage: string;
  DataListModel: DataListModel;
  defaultContractypeGroupList: any;
  sharedVehicleGroupHashID: string;
  urlSVGList: string;
  sharedvehicleGroup: string;
  dayofWeekList: any;
  vatSettingList: DropdownModel[];
  vatSettingDefaultValues: VatDefaultModel;

  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;

  @ViewChild('sucessModal') public sucessModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(
    private subscriptionService: SubscriptionService,
    private sharedVehicleGroupService: SharedVehicleGroupService,
    private contractTypeGroupService: ContractTypeGroupService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private locationService: Location
  ) {}

  ngOnInit() {
    this.module = this.translate.instant('LblSubscription');

    //Invoice Moment day of week list

    this.dayofWeekList = [
      {
        Key: this.translate.instant('LblSelectDayOfWeek'),
        Value: ''
      },
      {
        Key: this.translate.instant('LblSunday'),
        Value: '0'
      },
      {
        Key: this.translate.instant('LblMonday'),
        Value: '1'
      },
      {
        Key: this.translate.instant('LblTuesday'),
        Value: '2'
      },
      {
        Key: this.translate.instant('LblWednesday'),
        Value: '3'
      },
      {
        Key: this.translate.instant('LblThursday'),
        Value: '4'
      },
      {
        Key: this.translate.instant('LblFriday'),
        Value: '5'
      },
      {
        Key: this.translate.instant('LblSaturday'),
        Value: '6'
      }
    ];
    //Subsctiption Time Interval
    this.timeIntervalList = [
      {
        Key: this.translate.instant('LblSelectSubscriptionInterval'),
        Value: '',
        Amount: 0
      },
      {
        Key: this.translate.instant('LblWeeklySub'),
        Value: 'WEEKLY',
        Amount: 7
      },
      {
        Key: this.translate.instant('LblMonthlySub'),
        Value: 'MONTHLY',
        Amount: 30
      },
      {
        Key: this.translate.instant('LblYearlySub'),
        Value: 'YEARLY',
        Amount: 365
      }
    ];

    this.InitiateIntervalList();
    this.sharedvehicleGroup = this.translate.instant(
      'LblListPage',
      this.translate.instant('LblSharedVehicleGroup')
    );
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlSubscriptionList = this.authService.GetURL(
      ApplicationRouteURL.URL_SUBSCRIPTION_LIST
    );
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.model = new SubscriptionModel();
    this.isEditMode = false;
    this.sub = this.activeRoute.params.subscribe(params => {
      this.subscriptionHashId = params['subscriptionHashId'] || '';
      this.sharedVehicleGroupHashID = params['sharedVehicleGroupHashId'] || '';
      this.GetVatSettingDropdownList();
      this.model.sharedVehicleGroupHashId = this.sharedVehicleGroupHashID;
      if (this.subscriptionHashId != '') {
        this.HandleEditMode();
      } else {
        this.GetCurrencyByGroup();
        this.GetContractTypeGroupList();
      }
    });
    console.log(this.model);
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant('LblEditPage', [this.module])
      : this.translate.instant('LblAddPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
  }

  public HandleEditMode() {
    this.isEditMode = true;
    this.subscriptionService
      .GetSubscriptionByHashId(this.subscriptionHashId)
      .subscribe(
        res => {
          this.LoadIntervalList();

          this.model = res.data;
          if (res.data.defaultContractTypeGroupHashId == null) {
            this.model.defaultContractTypeGroupHashId = '';
            this.model.freeItemCTGHashId = '';
          }
          this.model.invoiceMomentDayOfWeek = res.data.invoiceMomentDayOfWeek;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        },
        () => {
          this.GetContractTypeGroupList();
        }
      );
  }

  public GetCurrencyByGroup() {
    this.contractTypeGroupService
      .GetCurrencyByGroup(this.sharedVehicleGroupHashID)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.model.currencySymbol = res.data.currencySymbol;
          } else {
            this.errorModel = res.error;
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public OnContactTypeGroupChecked() {
    this.defaultContractypeGroupList = this.contractTypeGroupList.filter(
      (x: any) => x.isChecked
    );
    if (
      !this.defaultContractypeGroupList.some(
        (item: any) =>
          item.contractTypeGroupHashId ==
          this.model.defaultContractTypeGroupHashId
      )
    ) {
      this.model.defaultContractTypeGroupHashId = '';
    }
  }

  OnSubmit(forms: any) {
    this.model.contractTypeGroupList = this.contractTypeGroupList
      .filter((x: any) => x.isChecked)
      .map((x: any) => x.contractTypeGroupHashId);
    this.subscriptionService.AddNewSubscription(this.model).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode
            ? this.translate.instant('LblRecordUpdatedSuccess', [this.module])
            : this.translate.instant('LblRecordAddedSuccess', [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetContractTypeGroupList() {
    this.contractTypeGroupService
      .GetContractTypeGroupBySharedVehicleGroup(
        this.sharedVehicleGroupHashID,
        this.DataListModel
      )
      .subscribe(
        res => {
          this.contractTypeGroupList = res.data;
          if (this.isEditMode) {
            this.contractTypeGroupList
              .filter(
                (x: any) =>
                  this.model.contractTypeGroupList.indexOf(
                    x.contractTypeGroupHashId
                  ) > -1
              )
              .forEach((x: any) => (x.isChecked = true));
          }
          this.defaultContractypeGroupList = this.contractTypeGroupList.filter(
            (x: any) => x.isChecked
          );
          console.log('contractTypeGroupList');
          console.log(this.contractTypeGroupList);
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetVatSettingDropdownList() {
    this.contractTypeGroupService
      .GetVatSettingDropdownList(this.sharedVehicleGroupHashID)
      .subscribe(
        res => {
          if (res.data) {
            this.vatSettingList = res.data;
            if (!this.isEditMode) this.GetVatSettingDefaultValues();
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetVatSettingDefaultValues() {
    this.contractTypeGroupService
      .GetVatSettingDefaultValues(this.sharedVehicleGroupHashID)
      .subscribe(
        res => {
          if (res.data) {
            this.vatSettingDefaultValues = res.data;
            this.model.vatPercentage = this.vatSettingDefaultValues.defaultVatSubscriptionCost;
            this.model.vatSettingDefaultCost = this.vatSettingDefaultValues.vatSettingDefaultCost;
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public SuccessModalClick(): void {
    this.router.navigate([
      this.urlSubscriptionList,
      { sharedVehicleGroupHashId: this.sharedVehicleGroupHashID }
    ]);
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public SubscriptionOnChange() {
    if (this.model.timeInterval != '') {
      this.LoadIntervalList();

      var subscriptionInterval = this.timeIntervalList.find(
        (time: KeyPairAmount) => time.Value === this.model.timeInterval
      );
      this.paymentIntervalList = this.paymentIntervalList.filter(
        (x: KeyPairAmount) =>
          this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount)
      );
      this.invoiceIntervalList = this.invoiceIntervalList.filter(
        (x: KeyPairAmount) =>
          this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount)
      );
      this.freeKiloMetersIntervalList = this.freeKiloMetersIntervalList.filter(
        (x: KeyPairAmount) =>
          this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount)
      );
      this.freeMinutIntervalList = this.freeMinutIntervalList.filter(
        (x: KeyPairAmount) =>
          this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount)
      );

      // if (!this.invoiceIntervalList.some((item: any) => item.Value == this.model.invoiceInterval)) {
      //   this.model.invoiceInterval = '';
      // }
      this.ResetInterval();
    } else {
      this.InitiateIntervalList();
      this.ResetInterval();
    }
  }

  public PaymentIntervalOnChange() {
    if (this.model.paymentInterval != '') {
      this.LoadInvoiceInterval();

      var subscriptionInterval = this.timeIntervalList.find(
        (time: KeyPairAmount) => time.Value === this.model.timeInterval
      );
      this.invoiceIntervalList = this.invoiceIntervalList.filter(
        (x: KeyPairAmount) =>
          this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount)
      );
      this.paymentIntervalList = this.paymentIntervalList.filter(
        (x: KeyPairAmount) =>
          this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount)
      );
      var paymentInterval = this.paymentIntervalList.find(
        (time: KeyPairAmount) => time.Value === this.model.paymentInterval
      );
      if (this.model.paymentInterval == 'PERBOOKING') {
        this.invoiceIntervalList = this.invoiceIntervalList.filter(
          (x: KeyPairAmount) =>
            this.HandleInvoiceInterval(x.Amount, paymentInterval.Amount)
        );
      } else {
        this.invoiceIntervalList = this.invoiceIntervalList.filter(
          (x: KeyPairAmount) =>
            this.HandleInvoiceInterval(x.Amount, subscriptionInterval.Amount)
        );
      }

      this.model.invoiceInterval = '';
    } else {
      //Invoice Interval List
      this.invoiceIntervalList = [
        {
          Key: this.translate.instant('LblSelectInvoiceInterval'),
          Value: '',
          Amount: 0
        }
      ];
      this.model.invoiceInterval = '';
    }
  }

  private HandleValidationInterval(
    intervalAmount: any,
    subscriptionIntervalAmount: any
  ) {
    return (
      (subscriptionIntervalAmount != 7 &&
        (intervalAmount <= subscriptionIntervalAmount &&
          intervalAmount != 7)) ||
      (subscriptionIntervalAmount == 7 &&
        (intervalAmount == 7 || intervalAmount == 0 || intervalAmount == 0.5))
    );
  }

  private HandleInvoiceInterval(
    intervalAmount: any,
    paymentIntervalAmount: any
  ) {
    return (
      (paymentIntervalAmount != 0.5 &&
        (intervalAmount <= paymentIntervalAmount && intervalAmount != 0.5)) ||
      (paymentIntervalAmount == 0.5 &&
        (intervalAmount == 0.5 || intervalAmount == 0))
    );
  }

  //Initiate interval lists with default elements
  private InitiateIntervalList() {
    //Payment Interval List
    this.paymentIntervalList = [
      {
        Key: this.translate.instant('LblSelectPaymentInterval'),
        Value: '',
        Amount: 0
      }
    ];

    //Invoice Interval List
    this.invoiceIntervalList = [
      {
        Key: this.translate.instant('LblSelectInvoiceInterval'),
        Value: '',
        Amount: 0
      }
    ];

    //Free KM Interval List
    this.freeKiloMetersIntervalList = [
      {
        Key: this.translate.instant('LblSelectFreeKMInterval'),
        Value: '',
        Amount: 0
      }
    ];

    //Free Min Interval List
    this.freeMinutIntervalList = [
      {
        Key: this.translate.instant('LblSelectFreeMinInterval'),
        Value: '',
        Amount: 0
      }
    ];
  }

  //Load interval list with all elemnets
  private LoadIntervalList() {
    //Payment Interval
    this.paymentIntervalList = [
      {
        Key: this.translate.instant('LblSelectPaymentInterval'),
        Value: '',
        Amount: 0
      },
      {
        Key: this.translate.instant('LblPerBooking'),
        Value: 'PERBOOKING',
        Amount: 0.5
      },
      {
        Key: this.translate.instant('LblWeeklySub'),
        Value: 'WEEKLY',
        Amount: 7
      },
      {
        Key: this.translate.instant('LblMonthlySub'),
        Value: 'MONTHLY',
        Amount: 30
      },
      {
        Key: this.translate.instant('LblYearlySub'),
        Value: 'YEARLY',
        Amount: 365
      }
    ];

    //Invoice Interval List
    this.invoiceIntervalList = [
      {
        Key: this.translate.instant('LblSelectInvoiceInterval'),
        Value: '',
        Amount: 0
      },
      {
        Key: this.translate.instant('LblPerBooking'),
        Value: 'PERBOOKING',
        Amount: 0.5
      },
      {
        Key: this.translate.instant('LblWeeklySub'),
        Value: 'WEEKLY',
        Amount: 7
      },
      {
        Key: this.translate.instant('LblMonthlySub'),
        Value: 'MONTHLY',
        Amount: 30
      },
      {
        Key: this.translate.instant('LblYearlySub'),
        Value: 'YEARLY',
        Amount: 365
      }
    ];

    //Free KM Interval List
    this.freeKiloMetersIntervalList = [
      {
        Key: this.translate.instant('LblSelectFreeKMInterval'),
        Value: '',
        Amount: 0
      },
      {
        Key: 'PER DAY',
        Value: 'DAILY',
        Amount: 1
      },
      {
        Key: this.translate.instant('LblFreePerWeek'),
        Value: 'WEEKLY',
        Amount: 7
      },
      {
        Key: this.translate.instant('LblFreePerMonth'),
        Value: 'MONTHLY',
        Amount: 30
      },
      {
        Key: this.translate.instant('LblFreePerTriMonth'),
        Value: 'TRIMONTHLY',
        Amount: 91
      },
      {
        Key: this.translate.instant('LblFreePerBiannual'),
        Value: 'BIANNUALLY',
        Amount: 182
      },
      {
        Key: this.translate.instant('LblFreePerYear'),
        Value: 'YEARLY',
        Amount: 365
      },
      {
        Key: this.translate.instant('LblFreePerBookingInterval'),
        Value: 'BOOKING_INTERVAL',
        Amount: 0.5
      }
    ];

    //Free Min Interval List
    this.freeMinutIntervalList = [
      {
        Key: this.translate.instant('LblSelectFreeMinInterval'),
        Value: '',
        Amount: 0
      },
      {
        Key: 'PER DAY',
        Value: 'DAILY',
        Amount: 1
      },

      {
        Key: this.translate.instant('LblFreePerWeek'),
        Value: 'WEEKLY',
        Amount: 7
      },
      {
        Key: this.translate.instant('LblFreePerMonth'),
        Value: 'MONTHLY',
        Amount: 30
      },
      {
        Key: this.translate.instant('LblFreePerTriMonth'),
        Value: 'TRIMONTHLY',
        Amount: 91
      },
      {
        Key: this.translate.instant('LblFreePerBiannual'),
        Value: 'BIANNUALLY',
        Amount: 182
      },
      {
        Key: this.translate.instant('LblFreePerYear'),
        Value: 'YEARLY',
        Amount: 365
      },
      {
        Key: this.translate.instant('LblFreePerBookingInterval'),
        Value: 'BOOKING_INTERVAL',
        Amount: 0.5
      }
    ];
  }

  //Reset Intervals
  private ResetInterval() {
    this.model.invoiceInterval = '';
    this.model.paymentInterval = '';
    this.model.freeKilometerInterval = '';
    this.model.freeMinuteInterval = '';
  }

  public LoadInvoiceInterval() {
    this.invoiceIntervalList = [
      {
        Key: this.translate.instant('LblSelectInvoiceInterval'),
        Value: '',
        Amount: 0
      },
      {
        Key: this.translate.instant('LblPerBooking'),
        Value: 'PERBOOKING',
        Amount: 0.5
      },
      {
        Key: this.translate.instant('LblWeeklySub'),
        Value: 'WEEKLY',
        Amount: 7
      },
      {
        Key: this.translate.instant('LblMonthlySub'),
        Value: 'MONTHLY',
        Amount: 30
      },
      {
        Key: this.translate.instant('LblYearlySub'),
        Value: 'YEARLY',
        Amount: 365
      }
    ];
  }

  public InitializePymentInterval() {
    this.paymentIntervalList = [
      {
        Key: this.translate.instant('LblSelectPaymentInterval'),
        Value: '',
        Amount: 0
      }
    ];

    //Invoice Interval List
    this.invoiceIntervalList = [
      {
        Key: this.translate.instant('LblSelectInvoiceInterval'),
        Value: '',
        Amount: 0
      }
    ];
  }

  public SetVatDefaultCost(vatSettingDefaultCost: boolean) {
    return vatSettingDefaultCost
      ? this.translate.instant('LblExcludingVat')
      : this.translate.instant('LblIncludingVat');
  }
  // TODO: Remove this when we're done
  // get diagnostic() { return JSON.stringify(this.model); }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroupsubscription/components/sharedvehicelsubscription-update.component.ts